import * as Sentry from '@sentry/react';
import { Typography } from '@ui-components/neo.tax';
import React from 'react';

import { ReactComponent as DisclaimerIcon } from '@neo.tax/shared/assets/images/error.svg';
import { LocalStorageKey } from '@neo.tax/shared/enums';
import { StringBoolean } from '@neo.tax/shared/utils';

import { StyledErrorContainer, StyledTitleContainer } from './app-wide-error.styled';

export const AppWideError = (_errorData: {
  error: Error;
  componentStack: string | null;
  eventId: string | null;
  resetError(): void;
}): React.ReactElement<any, string | React.JSXElementConstructor<any>> => {
  try {
    const appReloadOnError = localStorage.getItem(LocalStorageKey.SESSION_ON_ERROR_RELOAD_STATE) ?? StringBoolean.FALSE;

    if (appReloadOnError === StringBoolean.TRUE) {
      location.reload();
      return <></>;
    }
  } catch (error) {
    // If we get an error attempting to reload the page or interact
    // with local-storage, we catch and report the error but we do
    // not want to throw because we are already in the catch-all
    Sentry.captureException(error, { extra: { source: 'AppWideError' } });
  }

  return (
    <StyledErrorContainer direction="column" alignItems="center" justifyContent="center">
      <StyledTitleContainer direction="column" justifyContent="space-between">
        <Typography fontSize="xl" lineHeight={9} as="h2">
          Something went wrong.
        </Typography>
        <Typography as="span">Try refreshing the page and contact us if the problem persists.</Typography>
      </StyledTitleContainer>
      <DisclaimerIcon />
    </StyledErrorContainer>
  );
};
